import Link from "next/link";
import { FunctionComponent } from "react";

import styles from "./BrandSources.module.scss";

import ReliabilitySource from "@components/generic/reliabilitySource";
import { HASHTAG } from "@lib/helper/stringUtils";
import { IBrandSource } from "@lib/store/models/brandsModels";

export interface IBrandSourcesProps {
  sources: IBrandSource[];
}

const BrandSources: FunctionComponent<IBrandSourcesProps> = ({ sources }) => {
  const _renderSourceItem = ({ name, link, date, reliability }: IBrandSource, key: number): JSX.Element => {
    return (
      <div key={key} className={styles["brand-sources__item"]}>
        <h4 className={styles["brand-sources__header"]}>
          <span className={styles["brand-sources__link"]}>
            {link ? (
              <Link href={link ? link : HASHTAG} target="popup">
                {name}
              </Link>
            ) : (
              name
            )}
          </span>
          {!!date && ` - ${date}`}
        </h4>
        <ReliabilitySource reliability={reliability} />
      </div>
    );
  };

  return <div className={styles["brand-sources"]}>{sources.map((item, index) => _renderSourceItem(item, index))}</div>;
};

export default BrandSources;
